import API from '../../api/api';
import * as type from "./action-type";
import * as echarts from "echarts";
import envconfig from '../../envconfig/envconfig';

const colors = ['#3118be', '#17be66', '#e6bc12', '#d93c0b', '#29b4e6', '#12a188'];

//通用控制显示/隐藏
export const handleKeyValue = (key, value) => {
    return {
        type: type.handleKeyValue,
        key: key,
        value: value
    }
}

//获取种、册、条目、指标个数
export const getDataCount = () => {
    let _url = '/Home/GetCount';
    // 返回函数，异步dispatch
    return async dispatch => {
        try {
            const result = await API.post(_url, {});
            const data = result.data || {};
            dispatch({
                type: type.Get_Count,
                data: data
            })
        } catch (err) {
            console.error(err);
        }
    }
}

//获取年鉴列表
export const getYearbookList = () => {
    let _url = '/Home/GetYearbookList';
    // 返回函数，异步dispatch
    return async dispatch => {
        try {
            let result = await API.post(_url, {});
            let data = result.data;
            Array.isArray(data) && data.forEach(item => {
                item.coverImageUrl = envconfig.coverImageUrl + '/' + item.number + '.jpg';
            })
            dispatch({
                type: type.GET_YearbookList,
                data: data
            })
        } catch (err) {
            console.error(err);
        }
    }
}

//获取统计公报
export const getStatNews = () => {
    let _url = '/Home/GetStatNews';
    const _data = {
        zoneCode: '100000',
        classCodes: ['A','B','C','D','E','F','G']
    }
    // 返回函数，异步dispatch
    return async dispatch => {
        try {
            const result = await API.post(_url, _data);
            const { areaStatNews = [], nationStatNews = [] } = result.data || {};
            const data = [nationStatNews, areaStatNews];
            dispatch({
                type: type.GET_StatNews,
                data: data
            })
        } catch (err) {
            console.error(err);
        }
    }
}

export const drawEChart0 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e'
                },
                top: 12
            },
            legend: {
                data: [
                    '全国人口（万人）',
                    '年均增长率（%）'
                ],
                top: 'bottom'
            },
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    if (params.length === 1) {
                        return params[0].name + '<br/>'
                            + params[0].marker + ' ' + params[0].value + data.unitBar
                    }
                    if (params.length > 1) {
                        return params[0].name + '<br/>'
                            + params[0].marker + ' ' + params[0].value + data.unitBar + '<br/>'
                            + params[1].marker + ' ' + params[1].value + data.unitLine;
                    }
                }
            },
            grid: {
                top: '20%',
                bottom: '15%',
                left: '14%'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: data.years,
                    axisLabel:{
                        interval:0
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    interval: 20000,
                    max: 160000,
                    axisLabel: {
                        show: true,
                        formatter: '{value}'
                    }
                },
                {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        formatter: '{value} ' + data.unitLine
                    }
                }
            ],
            series: [
                {
                    name: '全国人口（万人）',
                    type: 'bar',
                    data: data.valuesBar,
                    unit: '万人',
                    barWidth: 35,
                },
                {
                    name: '年均增长率（%）',
                    type: 'line',
                    data: data.valuesLine,
                    unit: '%',
                    yAxisIndex: 1,
                    label: {
                        show: true
                    }
                }
            ]
        };
        let dom = document.getElementById('Chart0');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }
        return dispatch({
            type: type.DrawEChart0,
            chart
        })
    }
}
export const drawEChart1 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e'
                },
                top: 12
            },
            legend: {
                data: [
                    '男性人口（万人）',
                    '女性人口（万人）',
                    '性别比（女性=100）'
                ],
                top: 'bottom'
            },
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    if (params.length === 1) {
                        return params[0].name + '<br/>'
                            + params[0].marker + ' ' + params[0].value + data.unitBar
                    }
                    if (params.length === 2) {
                        return params[0].name + '<br/>'
                            + params[0].marker + ' ' + params[0].value + data.unitBar + '<br/>'
                            + params[1].marker + ' ' + params[1].value + data.unitBar + '<br/>'
                    }
                    return params[0].name + '<br/>'
                        + params[0].marker + ' ' + params[0].value + data.unitBar + '<br/>'
                        + params[1].marker + ' ' + params[1].value + data.unitBar + '<br/>'
                        + params[2].marker + ' ' + params[2].value;
                }
            },
            grid: {
                top: '20%',
                bottom: '15%',
                left: '14%'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: data.years,
                    axisLabel:{
                        interval:0
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        formatter: '{value}'
                    }
                },
                {
                    type: 'value',
                    min: 100,
                    max: 120,
                    interval: 5,
                    axisLabel: {
                        show: true,
                        formatter: '{value}'
                    }
                }
            ],
            series: [
                {
                    name: '男性人口（万人）',
                    type: 'bar',
                    data: data.menValuesBar,
                    unit: '万人',
                },
                {
                    name: '女性人口（万人）',
                    type: 'bar',
                    data: data.womenValuesBar,
                    unit: '万人',
                },
                {
                    name: '性别比（女性=100）',
                    type: 'line',
                    data: data.valuesLine,
                    yAxisIndex: 1,
                    label: {
                        show: true,
                        color: '#FAC858'
                    },
                    symbol: 'triangle',
                    symbolSize: 12,
                }
            ]
        };
        let dom = document.getElementById('Chart1');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }

        return dispatch({
            type: type.DrawEChart1,
            chart
        })
    }
}
export const drawEChart2 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                left: 'center',
                textStyle: {
                    fontWeight: 400,
                    fontSize: 14
                },
                top: 12
            },
            tooltip: {
                trigger: 'axis',
                // formatter: '{b}</br>{c}'+data.unit
                formatter: function (params) {
                    if (params.length > 0) {
                        return params[0].name + '<br/>'
                            + params[0].marker + ' ' + params[0].value + data.unit;
                    }
                }
            },
            grid: {
                top: '20%',
                bottom: '10%',
                left: '60'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: data.years,
                    axisLabel:{
                        interval:0
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    axisLabel: {
                        show: true
                    }
                }
            ],
            series: [
                {
                    type: 'line',
                    data: data.values,
                    label: {
                        show: true,
                        formatter: (params) => (
                          parseFloat(params.value).toFixed(2)
                        )
                    },
                }
            ]
        };
        let dom = document.getElementById('Chart2');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }

        return dispatch({
            type: type.DrawEChart2,
            chart
        })
    }
}
export const drawEChart3 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e'
                },
                top: 12
            },
            legend: {
                top: 45,
                type: 'scroll',
                padding: [0, 34],
                data: ['1964年', '1982年', '1990年', '2000年', '2010年', '2020年'],
            },
            tooltip: {
                trigger: 'axis',
                valueFormatter: (value) => (
                    `${value} 人`
                )
            },
            grid: {
                top: '36%',
                bottom: '9%',
                left: '15%'
            },
            calculable: true,
            dataset: {
                source: data.dataSource,
            },
            xAxis: {
                type: 'category',
                axisLabel:{
                    interval:0
                }
            },
            yAxis: {
                name: '人',
                type: 'value',
                // axisLine: {
                //   show: true
                // },
                axisLabel: {
                    show: true
                },
            },
            series: [
                {type: 'bar'},
                {type: 'bar'},
                {type: 'bar'},
                {type: 'bar'},
                {type: 'bar'},
                {type: 'bar'},
            ]
        };
        let dom = document.getElementById('Chart0');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }
        return dispatch({
            type: type.DrawEChart0,
            chart
        })
    }
}
export const drawEChart4 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        const option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e'
                },
                top: 12
            },
            legend: {
                data: ['男', '女'],
                top: 38
            },
            tooltip: {
                trigger: 'axis',
                valueFormatter: (value) => (
                    `${value} 人`
                )
            },
            grid: {
                top: '30%',
                bottom: '9%',
                left: '20%',
                // right: '10%'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: data.xAxisData,
                    axisLabel:{
                        interval: 0 // 轴指标全部显示
                    }
                }
            ],
            yAxis: [
                {
                    name: '人',
                    type: 'value',
                    axisLabel: {
                        show: true,
                        formatter: '{value}'
                    }
                },
            ],
            series: [
                {
                    name: '男',
                    type: 'bar',
                    stack: 'sex',
                    emphasis: {
                        focus: 'none'
                    },
                    label: {
                        show: true,
                    },
                    // data: data.menValuesBar
                },
                {
                    name: '女',
                    type: 'bar',
                    stack: 'sex',
                    emphasis: { // 在高亮图形时，是否淡出其它数据的图形以达到聚焦的效果
                        focus: 'none'
                    },
                    data: data.womenValuesBar
                },
            ]
        };

        const menValueData = () => {
            const _data = [...data.menValuesBar]
            let offset = [0, 0]
            _data.forEach((item, index) => {
                if (index === 0) {
                    offset = [0, 2]
                }
                else if (index === 1) {
                    offset = [0, -6]
                }
                else if (index === 4) {
                    offset = [0, -2]
                }
                else if (index === 5) {
                    offset = [0, 8]
                }
                else {
                    offset = [0, 0]
                }
                _data[index] = {
                    value: item,
                    label: {
                       offset: offset
                    },
                }
            })
            return _data
        }

        option.series[0].data = menValueData();
        let dom = document.getElementById('Chart1');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }

        return dispatch({
            type: type.DrawEChart1,
            chart
        })
    }
}
export const drawEChart5 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e'
                },
                top: 12
            },
            legend: {
                data: [
                    '文盲人口（万人）',
                    '文盲率（%）'
                ],
                top: 'bottom'
            },
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    if (params.length === 1) {
                        return params[0].name + '<br/>'
                            + params[0].marker + ' ' + params[0].value + data.unitBar
                    }
                    if (params.length > 1) {
                        return params[0].name + '<br/>'
                            + params[0].marker + ' ' + params[0].value + data.unitBar + '<br/>'
                            + params[1].marker + ' ' + params[1].value + data.unitLine;
                    }
                }
            },
            grid: {
                top: '20%',
                bottom: '15%',
                left: '14%'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: data.years
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        formatter: '{value}'
                    }
                },
                {
                    type: 'value',
                    max: 40,
                    interval: 5,
                    axisLabel: {
                        show: true,
                        formatter: '{value} ' + data.unitLine
                    }
                }
            ],
            series: [
                {
                    name: '文盲人口（万人）',
                    type: 'bar',
                    data: data.valuesBar,
                    unit: '万人',
                },
                {
                    name: '文盲率（%）',
                    type: 'line',
                    data: data.valuesLine,
                    unit: '%',
                    yAxisIndex: 1,
                    label: {
                        show: true
                    }
                }
            ]
        };
        let dom = document.getElementById('Chart2');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }
        return dispatch({
            type: type.DrawEChart2,
            chart
        })
    }
}
export const drawEChart6 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e',
                    left: 'left',
                },
                top: 12
            },
            legend: {
                data: ['男', '女'],
                top: 'bottom',
                left: 190
            },
            tooltip: {
                trigger: 'axis',
                valueFormatter: function (value) {
                    if (value < 0) {
                        return -value + '%';
                    }
                    return value + '%';
                }
            },
            grid: {
                top: '15%',
                bottom: '15%',
                left: '18%'
            },
            calculable: true,
            xAxis: [
                {
                    name: '%',
                    type: 'value',
                    interval: 2.0,
                    axisLine: {
                        show: true
                    },
                    axisLabel: {//把x轴的负数改成正数，如果需要负数把axisLabel删掉就行
                        formatter: function (value) {
                            if (value === 0) {
                                return value
                            }
                            if (value < 0) {
                                return ((-value).toFixed(1));
                            }
                            return value.toFixed(1);
                        }
                    },
                }
            ],
            yAxis: [
                {
                    // name: '年龄',
                    type: 'category',
                    axisTick: {
                        show: false
                    },
                    data: data.yAxisData
                },
            ],
            series: [
                {
                    name: '男',
                    type: 'bar',
                    stack: 'sex',
                    label: {
                        show: true,
                        position: 'left',
                        fontSize: 11,
                        formatter: function (value) { //把数据也转换成正数
                            if (value.data < 0) {
                                return -value.data;
                            }
                        },
                    },
                    data: data.menValues
                },
                {
                    name: '女',
                    type: 'bar',
                    stack: 'sex',
                    label: {
                        show: true,
                        position: 'right',
                        fontSize: 11,
                    },
                    data: data.womenValues
                }
            ]
        };
        let dom = document.getElementById('Chart0');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }
        return dispatch({
            type: type.DrawEChart0,
            chart
        })
    }
}
export const drawEChart7 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e'
                },
                top: 12
            },
            legend: {},
            tooltip: {
                trigger: 'axis',
                valueFormatter: (value) => (
                    parseFloat(value).toFixed(1) + '万人'
                )
            },
            grid: {
                top: '24%',
                bottom: '10%',
                left: '14%'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: data.years,
                    axisLabel:{
                        interval:0
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    min: 0,
                    max: 20000,
                    interval: 2000,
                    axisLabel: {
                        show: true,
                        formatter: '{value}'
                    }
                },
            ],
            series: [
                {
                    type: 'bar',
                    data: data.values,
                    unit: '万人',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: (params) => (
                            parseFloat(params.value).toFixed(1)
                        )
                    }
                },
            ]
        };
        let dom = document.getElementById('Chart1');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }
        return dispatch({
            type: type.DrawEChart1,
            chart
        })
    }
}
export const drawEChart8 = (data, _chart) => {
    return async dispatch => {
        if (_chart) {
            _chart.dispose();
        }
        let option = {
            color: colors,
            title: {
                text: data.title,
                subtext: data.subTitle,
                left: 'center',
                textStyle: {
                    color: '#0a0e1e',
                    fontWeight: 400,
                    fontSize: 14
                },
                subtextStyle: {
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#0a0e1e'
                },
                top: 12
            },
            legend: {},
            tooltip: {
                trigger: 'axis',
                valueFormatter: (value) => (
                    value + '%'
                )
            },
            grid: {
                top: '24%',
                bottom: '10%',
                left: '14%'
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: data.years,
                    axisLabel:{
                        interval:0
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    min: 0,
                    max: 16,
                    interval: 2,
                    axisLabel: {
                        show: true,
                        formatter: '{value}'
                    }
                },
            ],
            series: [
                {
                    type: 'line',
                    data: data.values,
                    unit: '%',
                    label: {
                        show: true,
                        formatter: (params) => (
                            parseFloat(params.value).toFixed(2)
                        )
                    },
                    markLine: { // 基准线
                        silent: true,
                        lineStyle: {
                            normal: {
                                color: '#17be66'
                            }
                        },
                        data: [{
                            yAxis: 7
                        }],
                        label: {
                            normal: {
                                position: 'insideEndBottom',
                                formatter: '7%国际老龄化标准',
                            }
                        },
                    },
                },
            ]
        };
        let dom = document.getElementById('Chart2');
        // 基于准备好的dom，初始化echarts实例
        let chart = echarts.init(dom);
        chart.setOption(option);
        window.onresize = function () {
            chart.resize();
        }
        return dispatch({
            type: type.DrawEChart2,
            chart
        })
    }
}

